import React from 'react'
import PageWrapper from 'wrappers/PageWrapper/PageWrapper'
import TechlinkRouter from 'bundles/iframe/techlink/TechlinkRouter'

const TechlinkIFrame = (props) => {
    const { user } = props

    return (
        <PageWrapper
            user={user}
            page='techlink'
            disableNavbar
            disableFooter
        >
            <TechlinkRouter {...props}/>
        </PageWrapper>
    )
}

export default TechlinkIFrame
